'use server';
import { actionErrorMessage } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';

export async function deleteIllustration(bookId: string): Promise<ActionResult<void>> {
  try {
    const familyId = await SessionService.getFamilyId();
    const userId = await SessionService.getUserId();
    if (!familyId || !userId) return { success: false, error: 'Not authenticated' };

    const { IllustrationService } = await import('@/contexts/illustrations/services/BookService');
    const { getIllustrationRepository } = await import('@/contexts/illustrations/repositories');
    const { getStoryRepository } = await import('@/contexts/stories/repositories');
    const { getCharacterRepository } = await import('@/contexts/characters/repositories');

    const illustrationService = new IllustrationService(getIllustrationRepository(), getStoryRepository(), getCharacterRepository());
    const success = await illustrationService.deleteIllustration(bookId, familyId);

    if (!success) {
      return { success: false, error: 'BOOK_NOT_FOUND' };
    }

    return { success: true, data: undefined };
  } catch (e: unknown) {
    return { success: false, error: actionErrorMessage('deleteBook', e) };
  }
}
